module.exports = __webpack_public_path__ + "img/bg.eee05042.png";